module.exports = __webpack_public_path__ + "img/background_img.c35e6892.png";